/* eslint-disable yola/react/require-default-props */
import React, { useCallback, forwardRef } from 'react';
import { useController } from 'react-hook-form';
import SimpleSelect from '../simple-select';
import FieldStatus from '../field-status';
const defaultRules = {};
const defaultOptions = [];

const flattenOptions = (options) =>
  options.reduce((accumulator, option) => {
    if ('options' in option) {
      return accumulator.concat(option.options);
    }
    return accumulator.concat(option);
  }, []);

const findOptionByValue = (options, value) => {
  if (value == null) {
    return undefined;
  }
  return flattenOptions(options).find((option) => option.value === value);
};

const SimpleSelectField = forwardRef(
  (
    {
      name,
      options = defaultOptions,
      control,
      rules = defaultRules,
      onChange,
      onBlur,
      ...otherProps
    },
    ref
  ) => {
    const { field, fieldState } = useController({
      name,
      control,
      rules,
    });

    const handleChange = useCallback(
      (option) => {
        const nextValue = option ? option.value : null;
        field.onChange(nextValue);
        onChange?.(option);
      },
      [field, onChange]
    );

    const handleBlur = useCallback(() => {
      field.onBlur();
      onBlur?.();
    }, [field, onBlur]);

    const currentValue = field.value;
    const defaultValue = findOptionByValue(options, currentValue);

    return (
      <React.Fragment>
        <SimpleSelect
          {...otherProps}
          ref={ref}
          onChange={handleChange}
          onBlur={handleBlur}
          options={options}
          defaultValue={defaultValue}
          name={field.name}
          invalid={fieldState.invalid}
        />
        {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
      </React.Fragment>
    );
  }
);

SimpleSelectField.displayName = 'SimpleSelectField';

export default SimpleSelectField;
